import { Flex, Typography, colors } from '@aloft/toolkit-sui';

const iconButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  margin: 0,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  lineHeight: 0,
  width: 12,
  height: 12,
  flexShrink: 0,
} as const;

const DecreaseIcon = () => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none" aria-hidden>
    <path
      d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM9 6C9 6.33137 8.73137 6.6 8.4 6.6H3.6C3.26863 6.6 3 6.33137 3 6C3 5.66863 3.26863 5.4 3.6 5.4H8.4C8.73137 5.4 9 5.66863 9 6Z"
      fill={colors.textLight}
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

const IncreaseIcon = () => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none" aria-hidden>
    <path
      d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM9 6C9 6.33137 8.73137 6.6 8.4 6.6H6.6V8.4C6.6 8.73137 6.33137 9 6 9C5.66863 9 5.4 8.73137 5.4 8.4V6.6H3.6C3.26863 6.6 3 6.33137 3 6C3 5.66863 3.26863 5.4 3.6 5.4H5.4V3.6C5.4 3.26863 5.66863 3 6 3C6.33137 3 6.6 3.26863 6.6 3.6V5.4H8.4C8.73137 5.4 9 5.66863 9 6Z"
      fill={colors.textLight}
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export const SteppedPercentInput = ({
  value,
  onChange,
  min = 0,
  step = 5,
  unit = '%',
}: {
  value: number | '';
  onChange: (value: number | '') => void;
  min?: number;
  step?: number;
  unit?: string;
}) => {
  const numericValue = value === '' ? 0 : value;

  return (
    <Flex
      alignItems="center"
      gap="8px"
      height="40px"
      padding="8px"
      borderWidth="1px"
      borderStyle="solid"
      borderColor="strokeDefault"
      borderRadius="4px"
      backgroundColor="surface1"
      width="100%"
      minWidth={0}
    >
      <button
        type="button"
        aria-label="Decrease"
        style={iconButtonStyle}
        onClick={() => onChange(Math.max(min, numericValue - step))}
      >
        <DecreaseIcon />
      </button>
      <Flex flex={1} alignItems="center" justifyContent="center" gap="4px" minWidth={0}>
        <Typography variant="body2" color="textPrimary" textAlign="right">
          {value === '' ? '' : value}
        </Typography>
        <Typography variant="body2" color="textTertiary">
          {unit}
        </Typography>
      </Flex>
      <button
        type="button"
        aria-label="Increase"
        style={iconButtonStyle}
        onClick={() => onChange(numericValue + step)}
      >
        <IncreaseIcon />
      </button>
    </Flex>
  );
};
